import { create } from "zustand";

type DocumentFormValues = {
  documentType?: "ordinance" | "proclamation";
  number?: string;
  title?: string;
  description?: string;
  date?: Date;
  status?: "current" | "archived" | "proposed";
  category?: string;
  documentMediaId?: string;
};

type State = {
  isOpen: boolean;
  documentId: string | null;
  defaultValues: DocumentFormValues;
};

type Actions = {
  setIsModalOpen: (isOpen: boolean) => void;
  setDocumentId: (id: string | null) => void;
  setDefaultValues: (values: DocumentFormValues) => void;
};

export const useDocumentsModal = create<State & Actions>((set) => ({
  isOpen: false,
  documentId: null,
  defaultValues: {},
  setIsModalOpen: (isOpen) => set({ isOpen }),
  setDocumentId: (id) => set({ documentId: id }),
  setDefaultValues: (values) => set({ defaultValues: values }),
}));
